import React from 'react';
import { Stack, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import FormatPhoneInput from '../../../../components/FormatNumber/FormatPhoneInput';

const ManagerDetailsForm = (): JSX.Element => {
  const { control } = useFormContext();

  return (
    <Stack spacing={1} sx={{ flex: '1 0 160px' }}>
      <Controller
        name="firstName"
        control={control}
        render={({ field }) => (
          <TextField placeholder="First Name" size="small" {...field} />
        )}
      />
      <Controller
        name="lastName"
        control={control}
        render={({ field }) => (
          <TextField placeholder="Last Name" size="small" {...field} />
        )}
      />
      <Controller
        name="email"
        control={control}
        render={({ field }) => (
          <TextField placeholder="Email" size="small" {...field} />
        )}
      />
      <Controller
        name="phoneNumber"
        control={control}
        render={({ field }) => (
          <TextField
            placeholder="Phone Number"
            size="small"
            {...field}
            InputProps={{
              // eslint-disable-next-line
              inputComponent: FormatPhoneInput as any
            }}
          />
        )}
      />
    </Stack>
  );
};

export default ManagerDetailsForm;
